export const galleryContainerSx = {
  width: '100%',
  display: 'flex',
  flexWrap: 'wrap',
  marginTop: '48px',
};

export const columnSx = { flex: '48.5%' };
